import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
  subWeeks,
} from "date-fns";
import { DateInput, TimeInput } from "../../Calendar/CalendarComponents";
import type { DateSelected } from "..";
import * as styles from "./styles.css";

interface CalendarInputsProps {
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
}

export const CalendarInputs = ({
  selectedDate,
  setSelectedDate,
}: CalendarInputsProps) => {
  return (
    <div className={styles.inputsArea}>
      <div className={styles.dateHourInput}>
        <DateInput
          value={selectedDate}
          setValue={(e) => {
            setSelectedDate(e);
          }}
        />
        <TimeInput
          value={selectedDate}
          setValue={(e) => {
            setSelectedDate(e);
          }}
        />
      </div>
    </div>
  );
};

export const OPTIONS_FUNCTIONS = {
  Hoje: () => ({
    start: startOfDay(new Date()),
    end: endOfDay(new Date()),
  }),
  Ontem: () => {
    const yesterday = subDays(new Date(), 1);
    return {
      start: startOfDay(yesterday),
      end: endOfDay(yesterday),
    };
  },
  "Essa semana": () => ({
    start: startOfWeek(new Date()),
    end: endOfWeek(new Date()),
  }),
  "Semana passada": () => {
    const lastWeek = subWeeks(new Date(), 1);
    return {
      start: startOfWeek(lastWeek),
      end: endOfWeek(lastWeek),
    };
  },
  "Esse mês": () => ({
    start: startOfMonth(new Date()),
    end: endOfMonth(new Date()),
  }),
  "Mês passado": () => {
    const lastMonth = subMonths(new Date(), 1);
    return {
      start: startOfMonth(lastMonth),
      end: endOfMonth(lastMonth),
    };
  },
  "Esse ano": () => ({
    start: startOfYear(new Date()),
    end: endOfYear(new Date()),
  }),
};

interface CalendarOptionsProps {
  hideOptions: Array<keyof typeof OPTIONS_FUNCTIONS>;
  setSelectedDate: (date: DateSelected) => void;
  handleSelectDate: (date: DateSelected) => void;
}

export const CalendarOptions = ({
  hideOptions,
  setSelectedDate,
  handleSelectDate,
}: CalendarOptionsProps) => {
  return (
    <ul className={styles.optionsList}>
      {Object.keys(OPTIONS_FUNCTIONS)
        .filter(
          (option) =>
            !hideOptions.includes(option as keyof typeof OPTIONS_FUNCTIONS),
        )
        .map((option) => {
          return (
            <li
              key={option}
              onClick={() => {
                // setHoveredDays([]);
                setSelectedDate(
                  OPTIONS_FUNCTIONS[option as keyof typeof OPTIONS_FUNCTIONS](),
                );
                handleSelectDate(
                  OPTIONS_FUNCTIONS[option as keyof typeof OPTIONS_FUNCTIONS](),
                );
              }}
            >
              {option}
            </li>
          );
        })}
    </ul>
  );
};
